import e from"react";var r=r=>(Array.isArray(r)?r:[r]).map((r,a)=>e.isValidElement(r)&&null==r.key?e.cloneElement(r,{key:a}):r);export{r as withReactKeys};
//# sourceMappingURL=withReactKeys.js.map